import React, { useState } from "react";
import ImageModal from "./ImageModal";
import CardRail from "./CardRail";
import FadeInSection from "./FadeInSection";
import SectionHeading from "./SectionHeading";

const CERTIFICATIONS = [
    {
        id: 1,
        title: "Postman API Fundamentals Student Expert",
        image: "/assets/certifications/postman_badge.png",
        link: "https://badgr.com/public/assertions/VApVANiRQs6F9mefjoT7qQ",
    },
    {
        id: 2,
        title: "AWS Educate — Introduction to Cloud 101",
        image: "/assets/certifications/aws-introduction-to-cloud-101.png",
        link: "https://www.credly.com/badges/3a9e32a0-b436-4927-a5c9-0f92cf033b79/public_url",
    },
    {
        id: 3,
        title: "Kubernetes From 10,000 Feet",
        image: "/assets/certifications/kubernetes.png",
    },
    {
        id: 4,
        title: "GitHub Version Controlling 101",
        image: "/assets/certifications/version_c.png",
    },
    {
        id: 5,
        title: "Introduction to Internet of Things",
        image: "/assets/certifications/iot.png",
        link: "https://www.credly.com/badges/affaa388-83da-47de-a662-056019807e20/public_url",
    },
    {
        id: 6,
        title: "Introduction to SOLID Principles",
        image: "/assets/certifications/Solid.png",
        link: "https://10pearlsuniversity.org/view-certificate?cid=10PUC-c895fc01fd3539b7232dd0d45dbe3ada65ba88dc5c07566c378539853",
    },
];

const Certifications = () => {
    const [modal, setModal] = useState({ open: false, src: "", title: "" });

    const openModal = (src, title) => setModal({ open: true, src, title });
    const closeModal = () => setModal({ open: false, src: "", title: "" });

    return (
        <section id="certifications" className="section">
            <div className="shell">
                <FadeInSection>
                    <SectionHeading index="04" title="certifications" />
                </FadeInSection>
                <FadeInSection>
                    <CardRail
                        items={CERTIFICATIONS}
                        onImageClick={openModal}
                        autoScroll
                    />
                </FadeInSection>
            </div>

            <ImageModal
                open={modal.open}
                src={modal.src}
                title={modal.title}
                onClose={closeModal}
            />
        </section>
    );
};

export default Certifications;
